import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/services/auth.service';
import { StreappEventsService } from 'src/app/services/streapp-events.service';

@Component({
  selector: 'app-delete-account-dialog',
  templateUrl: './delete-account-dialog.component.html',
  styleUrl: './delete-account-dialog.component.scss',
})
export class DeleteAccountDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<DeleteAccountDialogComponent>,
    private readonly authService: AuthService,
    private readonly streappService: StreappEventsService,
    private readonly materialSnackbar: MatSnackBar
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  delete(): void {
    var contactData = {
      Name: this.authService.name,
      Email: this.authService.email,
      Message: `Gebruiker heeft aangevraagd om zijn/haar account te verwijderen.`
    };

    // Doesn't give success return atm
    this.streappService.sendContact(JSON.stringify(contactData));

    this.materialSnackbar.open(
      `Er is een aanvraag verstuurd naar ons team!`,
      'Ok',
      {
        duration: 5000,
        panelClass: 'snackbar-successful',
      }
    );

    this.dialogRef.close();
  }
}
